"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationSelectList = exports.LocationSelectListType = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/*
 * LocationSelectList.tsx
 * Author: amusiol
 * Date: 17.10.2022
 *
 * Copyright: DMT GmbH & Co. KG
 */
const react_1 = require("react");
const Input_1 = require("./Input");
const Global_1 = require("../functions/Global");
var LocationSelectListType;
(function (LocationSelectListType) {
    LocationSelectListType[LocationSelectListType["MetrologyWizard"] = 1] = "MetrologyWizard";
})(LocationSelectListType = exports.LocationSelectListType || (exports.LocationSelectListType = {}));
const LocationSelectList = (props) => {
    const [list, setList] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        if (props.locations) {
            switch (props.type) {
                case LocationSelectListType.MetrologyWizard: {
                    const tmp = [{ value: 'none', label: '-- none --' }];
                    for (const key in props.locations) {
                        tmp.push({
                            value: key,
                            label: props.locations[key].location_name,
                        });
                    }
                    ;
                    setList(tmp);
                    break;
                }
                default: {
                    const tmp = [];
                    for (const key in props.locations) {
                        tmp.push({
                            value: props.locations[key].location_id,
                            label: props.locations[key].location_name,
                        });
                    }
                    ;
                    setList(tmp);
                    break;
                }
            }
        }
        else {
            (0, Global_1.getLocations)(props.projectId, props.keycloakfetch, props.settings).then(result => {
                const tmp = [];
                result.forEach((key) => {
                    tmp.push({
                        value: key.location_id,
                        label: key.location_name,
                    });
                });
                setList(tmp);
            });
        }
        return () => setList([]);
    }, [props.locations]);
    let input = (0, jsx_runtime_1.jsx)(Input_1.Input, { name: 'location_id', edit: true, label: props.label, tooltip: props.tooltip, disabled: typeof props.disabled === 'boolean' ? props.disabled : false, showClear: true, dropdownOptions: list, type: 'dropdown', onChange: (e) => {
            if (props.onChange)
                props.onChange(e);
        }, value: props.value });
    if (props.validationControl)
        input = (0, jsx_runtime_1.jsx)(Input_1.Input, { name: 'location_id', edit: true, label: props.label, tooltip: props.tooltip, disabled: typeof props.disabled === 'boolean' ? props.disabled : false, showClear: true, dropdownOptions: list, type: 'dropdown', onChange: (e) => {
                if (props.onChange)
                    props.onChange(e);
            }, validationControl: props.validationControl, validationErrorMessage: props.validationErrorMessage, validationRules: props.validationRules });
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: list && input }));
};
exports.LocationSelectList = LocationSelectList;
